export default [
    {
        path: "general",
        name: "settings-general",
        redirect: { name: "general-email" },
        component: () => import("@/views/settings/views/general/General.vue"),
        meta: {
            section: 2,
            breadcrumb: [
                {
                    text: "homework status",
                    active: true,
                },
            ],
            tabs: [
                {
                    title: "Email",
                    name: "general-email",
                },
            ],
        },
        children: [
            {
                path: "email",
                name: "general-email",
                redirect: { name: "general-email-event" },
                component: () => import(/* webpackChunkName: "GenearlEmail" */ "@/views/settings/views/general/components/email/Email.vue"),
                meta: {
                    section: 2,
                    pageTitle: "Email",
                    breadcrumb: [
                        {
                            text: "active",
                            active: true,
                        },
                    ],
                    tab: 1,
                    tabs: [

                        {
                            title: "Configure Recipients",
                            name: "general-email-config",
                        },
                        {
                            title: "Events",
                            name: "general-email-event",
                        },
                        {
                            title: "Recipients Group",
                            name: "general-email-recipients-group",
                        },

                    ],
                },
                children: [
                    {
                        path: "config",
                        name: "general-email-config",
                        component: () => import(/* webpackChunkName: "GenearlEmailRecipients" */ "@/views/settings/views/general/components/email/components/EmailConfig"),
                        meta: {
                            section: 2,
                            pageTitle: "Email",
                            breadcrumb: [
                                {
                                    text: "Configure Recipients",
                                    active: true,
                                },
                            ],
                            tab: 1,
                        },
                    },
                    {
                        path: "event",
                        name: "general-email-event",
                        component: () => import(/* webpackChunkName: "GenearlEmailEvent" */ "@/views/settings/views/general/components/email/components/EmailEvents.vue"),

                        meta: {
                            section: 2,
                            pageTitle: "Email",
                            breadcrumb: [
                                {
                                    text: "Events",
                                    active: true,
                                },
                            ],
                            tab: 2,
                        },
                    },

                    {
                        path: "recipients-group",
                        name: "general-email-recipients-group",
                        component: () => import(/* webpackChunkName: "GenearlEmailRecipientsGroup" */ "@/views/settings/views/general/components/email/components/EmailRecipientsGroups"),
                        meta: {
                            section: 2,
                            pageTitle: "Email",
                            breadcrumb: [
                                {
                                    text: "Recipients Group",
                                    active: true,
                                },
                            ],
                            tab: 3,
                        },
                    },

                ],
            },
            // {
            //   path: "Inactive",
            //   name: "homework-status-inactive",
            //   component: () =>
            //     import(
            //       /* webpackChunkName: "TareoStatusInactive" */ "@/views/settings/views/homework-status/components/Grid.vue"
            //     ),
            //   meta: {
            //     section: 2,
            //     breadcrumb: [
            //       {
            //         text: "homework status",
            //       },
            //       {
            //         text: "inactive",
            //         active: true,
            //       },
            //     ],
            //     tab: 2,
            //   },
            // },
        ],
    },
];
